import React from 'react';
import { Handshake } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { collaborationsData } from '../data/mock';

const Collaborations = () => {
  return (
    <section id="collaborations" className="py-24 bg-slate-900 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-96 h-96 bg-red-400 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-red-600 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            {collaborationsData.title}
          </h2>
          <h3 className="text-2xl font-semibold text-red-400 mb-6">
            {collaborationsData.subtitle}
          </h3>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto leading-relaxed">
            {collaborationsData.description}
          </p>
        </div>

        {/* Partners Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-6 max-w-6xl mx-auto">
          {collaborationsData.partners.map((partner, index) => (
            <Card
              key={partner.id}
              className="group hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 bg-slate-800/50 backdrop-blur-sm border-slate-700 hover:border-red-500 overflow-hidden"
              style={{
                animationDelay: `${index * 50}ms`
              }}
            >
              <CardContent className="p-6 flex flex-col items-center text-center">
                {/* Logo Circle */}
                <div className="w-16 h-16 rounded-full bg-gradient-to-br from-red-600 to-red-700 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300 shadow-lg shadow-red-500/30">
                  <span className="text-lg font-bold text-white">
                    {partner.logo}
                  </span>
                </div>
                
                {/* Partner Name */}
                <h4 className="text-sm font-semibold text-white leading-snug">
                  {partner.name}
                </h4>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Stats */}
        <div className="mt-16 flex items-center justify-center gap-12 text-center">
          <div>
            <div className="text-4xl font-bold text-red-400 mb-2">6+</div>
            <div className="text-slate-300 text-sm">Active Partners</div>
          </div>
          <div className="hidden sm:block w-px h-12 bg-slate-700"></div>
          <div>
            <div className="text-4xl font-bold text-red-400 mb-2">50+</div>
            <div className="text-slate-300 text-sm">Joint Projects</div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-20 text-center">
          <div className="inline-block bg-slate-800/50 backdrop-blur-sm border border-slate-700 rounded-2xl p-8 max-w-2xl">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-red-600 to-red-700 mb-4">
              <Handshake className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-2xl font-bold text-white mb-4">
              Interested in Collaborating?
            </h3>
            <p className="text-slate-300 mb-6 leading-relaxed">
              We're always open to partnering with talented agencies, creators, and freelancers who share our passion for quality digital marketing.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-3 text-sm text-slate-400">
              <span className="flex items-center gap-2">
                <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
                Currently accepting partnerships
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Collaborations;
